import { Department } from "@/models/department";
import { Pagination } from "@/models/pagination";
import { IDepartment, DepartmentState } from "@/types/department";
import { GeneralMutationTree } from "../generalMutation";

const mutations: GeneralMutationTree<DepartmentState, IDepartment> = {
  single: (state, single) => {
    state.single = new Department(single);
  },
  pagination: (state, pagination) => {
    pagination.data = pagination.data.map((item) => new Department(item));
    state.pagination = new Pagination(pagination);
  },
  clear: (state) => {
    state.single = new Department();
    state.pagination = new Pagination();
  },
};

export default mutations;
